export class ModelMarital
    {
        MaritalId : Number;
        MaritalName : string;
    }